import { render, staticRenderFns } from "./APrimeiraIgreja.vue?vue&type=template&id=23d192ee&scoped=true"
import script from "./APrimeiraIgreja.vue?vue&type=script&lang=js"
export * from "./APrimeiraIgreja.vue?vue&type=script&lang=js"
import style0 from "./APrimeiraIgreja.vue?vue&type=style&index=0&id=23d192ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d192ee",
  null
  
)

export default component.exports